import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import TableMgtSensorData from './TableMgtSensorData'
import actions from "../../redux/actions";
import FormSearch from "./FormSearch";

import AuthService from '../../service/Auth'

const Container = styled.div`

    .form-container{
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        @media only screen and (max-width: 1024px){
            width: 100%;
        }

        @media only screen and (max-width: 768px){
            width: 100%
        }
        
        @media only screen and (max-width: 450px){
            width: 100%
        }

        @media only screen and (max-width: 376px){
            width: 100%
        }

        @media only screen and (min-width: 1200px){
            width: 100%
        }
    }
`;



export default function Index(props) {

    const dispatch = useDispatch()
    const [permission, setPermission] = useState('')

    useEffect(() => {
        dispatch(actions.master.setPath("/mgt-sensor-data"))
        const init = async() =>{
            let permission = await AuthService.permission('mgt-sensor-data')
            if(permission) setPermission(permission)
        }

        init()
    }, [dispatch])
    
    return(
        <Container  className={"section-mgt-sensor-data" + (props.className ? props.className : "")}>
            <div className="page-title">
                <img src='/image/folder.png' alt="icon-folder"/>
                <span>จัดการข้อมูล</span>
            </div>
            <div className="form-container">
                <FormSearch />
            </div>
            <div className="table-container">
                <TableMgtSensorData permission={permission}/>
            </div>
        </Container>
    )
}